import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import home from '@/components/home'
import recharge from "../components/newstu/recharge";
import rechargePay from "../components/newstu/rechargePay";
import FeeProjectList from "../components/fee-project/FeeProjectList";
import FeeProjectDetail from "../components/fee-project/FeeProjectDetail";
import ConfirmOrder from '@/components/ConfirmOrder'
import DailyuseBook from '@/components/DailyuseBook'
import PaySuccess from '@/components/common/PaySuccess'
import PayFailed from '@/components/common/PayFailed'
import report from '@/components/report'
import registration from '@/components/registration'
import perdetiles from '@/components/perdetiles'
import PromptInformation from '@/components/PromptInformation'
import SearchScore from '@/components/SearchScore'
import SearchCourse from '@/components/SearchCourse'
import SchoolKnow from '@/components/schoolKnow'
import FeeMenu from '@/components/feeMenu'
import ScoreFailed from '@/components/ScoreFailed'
import PayTuition from '@/components/PayTuition'
import FeePaid from '@/components/FeePaid'
import EditInfo from '@/components/EditInfo'
import EditPic from '@/components/EditPic'
import ChangePhoneNum from '@/components/ChangePhoneNum'
import NewPhoneNum from '@/components/NewPhoneNum'
import VerPhoneNum from '@/components/VerPhoneNum'
import ChangePass from '@/components/ChangePass'
import ResetPass from '@/components/ResetPass'
import Auth from '@/components/Auth'
import NoticeDetail from '@/components/noticedetail'
import Notice from '@/components/Notice'
import noticeTransfer from '@/components/noticeTransfer'
import myNoticeApply from '@/components/myNoticeApply'
import noticeApply from '@/components/noticeApply'
import schoolcalendar from '@/components/schoolcalendar'
import militaryTrainingClothing from '@/components/militaryTrainingClothing'
import scanCodes from '@/components/scanCodes'
import dormitoryInformation from '@/components/dormitoryInformation'
import myDormitory from '@/components/myDormitory'
import applicationProfessionalTransfer from '@/components/applicationProfessionalTransfer'
import checkin from '@/components/newstu/checkin'
import More from '@/components/More'
import Advice from '@/components/Advice'
import Onlineevaluation from '@/components/Onlineevaluation'
import evaluationdetail from '@/components/evaluationdetail'
import evaluation from '@/components/evaluation'
import welcome from '@/components/newstu/welcome'
import livinguse from '@/components/newstu/livinguse'
import personalinformation from '@/components/newstu/personalinformation'
import schoolInformation from '@/components/newstu/schoolInformation'
import onlinefee from '@/components/newstu/onlinefee'
import friendRecommended from '@/components/newstu/friendRecommended'
import pay from '@/components/newstu/pay'
import selectdorm from '@/components/newstu/selectdorm'
import generateform from '@/components/newstu/generateform'
import delay from '@/components/newstu/delay'
import loan from '@/components/newstu/loan'
import checkloan from '@/components/audit/checkloan'
import loanDetile from '@/components/audit/loanDetile'
import reduceDetile from '@/components/audit/reduceDetile'
import checkReduce from '@/components/audit/checkReduce'
import uploadPic from '@/components/uploadPic'
import reduce from '@/components/newstu/reduce'
import setting from '../../server/settings'

Vue.use(Router)

export default new Router({
  base: setting.base_url,
  // mode: "history",
  routes: [{
    path: '/:app?',
    name: 'home',
    component: home,
      meta: {
          auth: true
      }
  }, {
      path: '/Login/:app?',
      name: 'Login',
      component: Login,
      meta: {
          auth: true
      }
  },
/*      {
    path: '/home',
    name: 'home',
    component: home,
    meta: {
        auth: true
    }
  },*/
      {
      path: '/more',
      name: 'more',
      component: More,
      /*meta: {
          auth: true
      }*/
  },{
      path: '/advice',
      name: 'advice',
      component: Advice,
      /*meta: {
          auth: true
      }*/
  },{
      path: '/evaluation',
      name: 'evaluation',
      component: Onlineevaluation,
      /*meta: {
          auth: true
      }*/
  },{
      path: '/gotoevaluation/:id',
      name: 'gotoevaluation',
      component: evaluation,
      /*meta: {
          auth: true
      }*/
  },{
      path: '/evaluationdetail',
      name: 'evaluationdetail',
      component: evaluationdetail,
      /*meta: {
          auth: true
      }*/
  },{
      path: '/Notice',
      name: 'Notice',
      component: Notice,
      /*meta: {
          auth: true
      }*/
  },{
      path: '/notice/:id',
      name: 'noticedetail',
      component: NoticeDetail,
      /*meta: {
          auth: true
      }*/
  },{
      path: '/searchscore/:stunum',
      name: 'searchscore',
      component: SearchScore,
      meta: {
          auth: true
      }
  },{
      path: '/searchcourse/:stunum',
      name: 'searchcourse',
      component: SearchCourse,
      meta: {
          auth: true
      }
  },{
      path: '/schoolKnow',
      name: 'schoolKnow',
      component: SchoolKnow,
      meta: {
          auth: true
      }
  },{
      path: '/feeMenu',
      name: 'feeMenu',
      component: FeeMenu,
      meta: {
          auth: true
      }
  },{
          path: '/schoolcalendar',
          name: 'schoolcalendar',
          component: schoolcalendar,
      },
      {
      path: '/scorefailed',
      name: 'scorefailed',
      component: ScoreFailed,
      /*meta: {
          auth: true
      }*/
  },{
      path: '/paytuition/:stunum',
      name: 'paytuition',
      component: PayTuition,
      /*meta: {
          auth: true
      }*/
  },{
      path: '/feepaid/:stunum?',
      name: 'feepaid',
      component: FeePaid,
      /*meta: {
          auth: true
      }*/
  }, {
      path: '/editinfo/:stunum',
      name: 'editinfo',
      component: EditInfo,
      /*meta: {
          auth: true
      }*/
  }, {
      path: '/editpic/:stunum',
      name: 'editpic',
      component: EditPic,
      /*meta: {
          auth: true
      }*/
  },{
      path: '/changephonenum/:stunum',
      name: 'changephonenum',
      component: ChangePhoneNum,
      /*meta: {
          auth: true
      }*/
  },{
      path: '/newphonenum/:stunum',
      name: 'newphonenum',
      component: NewPhoneNum,
      /*meta: {
          auth: true
      }*/
  },{
      path: '/verphonenum/:stunum',
      name: 'verphonenum',
      component: VerPhoneNum,
      /*meta: {
          auth: true
      }*/
  },{
      path: '/changepass/:stunum',
      name: 'changepass',
      component: ChangePass,
      /*meta: {
          auth: true
      }*/
  },{
      path: '/resetpass/:stunum',
      name: 'resetpass',
      component: ResetPass,
      /*meta: {
          auth: true
      }*/
  },{
      path: '/auth/:stunum',
      name: 'auth',
      component: Auth,
      /*meta: {
          auth: true
      }*/
  },
  {
    path: '/ConfirmOrder',
    name: 'ConfirmOrder',
    component: ConfirmOrder,
     /* meta: {
          auth: true
      }*/
  }, {
    path: '/DailyuseBook',
    name: 'DailyuseBook',
    component: DailyuseBook,
     /* meta: {
          auth: true
      }*/
  },
      {
    path: '/PaySuccess/:sort?/:stunum',
    name: 'PaySuccess',
    component: PaySuccess
  }, {
    path: '/PayFailed/:sort?/:stunum',
    name: 'PayFailed',
    component: PayFailed
  },
      {
    path: '/report',
    name: 'report',
    component: report,
      /*meta: {
          auth: true
      }*/
  }, {
    path: '/registration',
    name: 'registration',
    component: registration,
      /*meta: {
          auth: true
      }*/
  }, {
    path: '/perdetiles',
    name: 'perdetiles',
    component: perdetiles,
      /*meta: {
          auth: true
      }*/
  }, {
    path: '/PromptInformation',
    name: 'PromptInformation',
    component: PromptInformation,
     /* meta: {
          auth: true
      }*/
  },{
      path: '/militaryTrainingClothing',
      name: 'militaryTrainingClothing',
      component: militaryTrainingClothing,
      /* meta: {
           auth: true
       }*/
    },{
      path: '/scanCodes',
      name: 'scanCodes',
      component: scanCodes,
       meta: {
             auth: true
         }
    },{
      path: '/dormitoryInformation',
      name: 'dormitoryInformation',
      component: dormitoryInformation,
      /* meta: {
           auth: true
       }*/
    },
    {
      path: '/recharge/:stunum',
      name: 'recharge',
      component: recharge,
    },
    {
      path: '/rechargePay/:stunum',
      name: 'rechargePay',
      component: rechargePay,
    },
    {
	      path: '/feeProject/:stunum',
	      name: 'feeProject',
	      component: FeeProjectList,
	    },
	    {
	      path: '/feeProjectDetail/:stunum',
	      name: 'feeProjectDetail',
	      component: FeeProjectDetail,
	    },
    {
      path: '/myDormitory',
      name: 'myDormitory',
      component: myDormitory,
      /* meta: {
           auth: true
       }*/
    },{
      path: '/applicationProfessionalTransfer',
      name: 'applicationProfessionalTransfer',
      component: applicationProfessionalTransfer,
      /* meta: {
           auth: true
       }*/
    },{
      path: '/noticeTransfer',
      name: 'noticeTransfer',
      component: noticeTransfer,
      /* meta: {
           auth: true
       }*/
    },{
      path: '/myNoticeApply',
      name: 'myNoticeApply',
      component: myNoticeApply,
      /* meta: {
           auth: true
       }*/
    },
    {
      path: '/noticeApply',
      name: 'noticeApply',
      component: noticeApply,
      /* meta: {
           auth: true
       }*/
    },{
      path: '/checkin',
      name: 'checkin',
      component: checkin,
      /* meta: {
           auth: true
       }*/
    },{
      path: '/welcome/:stunum',
      name: 'welcome',
      component: welcome,
          meta: {
              auth: true
          }
  },{
          path: '/personalinformation/:sort/:stunum',
          name: 'personalinformation',
          component: personalinformation,
          meta: {
              auth: true
          }
      },{
          path: '/schoolInformation/:sort/:stunum',
          name: 'schoolInformation',
          component: schoolInformation,
          meta: {
              auth: true
          }
      }, {
          path: '/livinguse/:sort/:stunum',
          name: 'livinguse',
          component: livinguse,
          meta: {
              auth: true
          }
      }, {
          path: '/pay/:sort?/:stunum',
          name: 'pay',
          component: pay,
          meta: {
              auth: true
          }
      }, {
          path: '/onlinefee/:sort/:stunum',
          name: 'onlinefee',
          component: onlinefee,
          meta: {
              auth: true
          }
      }, {
          path: '/friendRecommended/:sort/:stunum',
          name: 'friendRecommended',
          component: friendRecommended,
          meta: {
              auth: true
          }
      },{
          path: '/selectdorm/:sort/:stunum',
          name: 'selectdorm',
          component: selectdorm,
          meta: {
              auth: true
          }
      },{
          path: '/generateform/:stunum',
          name: 'generateform',
          component: generateform,
          meta: {
              auth: true
          }
      },
      {
          path: '/delay/:stunum',
          name: 'delay',
          component: delay,
          meta: {
              auth: true
          }
      },
      {
          path: '/loan/:stunum',
          name: 'loan',
          component: loan,
          meta: {
              auth: true
          }
      },{
      path: '/checkloan',
      name: 'checkloan',
      component: checkloan,
      //   meta: {
      //       auth: true
      //   }
    },
    {
      path: '/loanDetile/:stunum',
      name: 'loanDetile',
      component: loanDetile,
    },{
      path: '/checkReduce',
      name: 'checkReduce',
      component: checkReduce,
      meta: {
        auth: true
      }
    },
    {
      path: '/reduceDetile/:stunum',
      name: 'reduceDetile',
      component: reduceDetile,
      //   meta: {
      //       auth: true
      //   }
    },
      {
          path: '/reduce/:stunum',
          name: 'reduce',
          component: reduce,
          meta: {
              auth: true
          }
      }, {
      path: '/uploadPic',
      name: 'uploadPic',
      component: uploadPic,
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js